import { type ChatEntry } from '@prisma/client';
import type { SessionContext } from 'server/src/context/context.type';
import { type Namespace as NamespaceType, type Socket as SocketType } from 'socket.io';

export namespace Chat {
    export const NAMESPACE = '/chat';

    interface EventBase {
        chatId: string;
    }

    export interface MessageEvent extends EventBase {
        entry: ChatEntry;
    }

    export type ChatEvent = EventBase

    export interface MemberEvent extends EventBase {
        memberId: string;
    }

    export interface ServerEvents {
        'message:created': (data: MessageEvent) => void;
        'message:updated': (data: MessageEvent) => void;
        'message:deleted': (data: MessageEvent) => void;
        'chat:created': (data: ChatEvent) => void;
        'chat:updated': (data: ChatEvent) => void;
        'chat:deleted': (data: ChatEvent) => void;
        'chat:read': (data: ChatEvent) => void;
        'member:joined': (data: MemberEvent) => void;
        'member:left': (data: MemberEvent) => void;
    }

    export interface ClientEvents {
        'chat:read': (data: ChatEvent) => void;
        'chat:active': (data: ChatEvent) => void;
        'chat:inactive': (data: ChatEvent) => void;
    }

    export interface InterServerEvents {
        ping: () => void;
    }

    export interface Data {
        user: SessionContext;
    }

    export type Namespace = NamespaceType<
        ClientEvents,
        ServerEvents,
        InterServerEvents,
        Data
    >;

    export type Socket = SocketType<
        ClientEvents,
        ServerEvents,
        InterServerEvents,
        Data
    >;
}
